// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"62adfdd9","239":"44375e30","488":"26278bec","667":"b946b092"}[chunkId] + ".chunk.js";
};